import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestMemberSubscriptionInvoiceList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/subscription`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/subscription?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}


export function requestMemberSubscriptionInvoiceCreate(params) {
  return fetch.post(
    `${BASE_URL}/api/app/subscription`,
    params
  );
}

export function requestForSubscriptionChangeStatus(value) {
  return fetch.patch(
    `${BASE_URL}/api/app/subscription/changeSubscriptionStatus`,
    {
      ...value,
    }
  );
}

export function requestMemberList(params) {
  if (params !== undefined) {
    return fetch.get(`${BASE_URL}/api/app/member?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else{
    return fetch.get(`${BASE_URL}/api/app/member`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}


export function requestSubscriptionPackageList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/subscription-package`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } 
}

export function requestGetByIdMemberSubscriptionInvoiceList(data) {
  return fetch.get(`${BASE_URL}/api/app/subscription/getById/${data.id}`);
}

// for PDF 
export function subscriptionInvoicePdf(data) {
  return fetch.post(`${BASE_URL}/api/app/subscription/subscriptionPDF/${data.id}`);
}